import * as d3 from "d3";
import { formatKr } from "utils/format";
import { convertSvgAttribute } from "utils/convertSvgAttribute";
export function initGraph(ref, margin) {
  var svg = d3.select(ref);
  var height = convertSvgAttribute(svg.style("height"));
  var width = convertSvgAttribute(svg.style("width"));
  svg.append("g").attr("class", "xGrid").attr("transform", "translate(".concat(-width, ",").concat(margin.top, ")"));
  svg.append("g").attr("class", "yGrid").attr("transform", "translate(".concat(-width, ",").concat(margin.top, ")"));
  svg.append("g").attr("class", "xTop").attr("transform", "translate(".concat(-width, ",").concat(margin.top, ")"));
  svg.append("g").attr("class", "xBottom").attr("transform", "translate(".concat(-width, ",").concat(height - margin.bottom, ")")).attr("needsPlacement", "true");
  var chart = svg.append("g").attr("class", "chartData");
  return {
    chart: chart,
    svg: svg
  };
}
export function updateAxes(_ref) {
  var svg = _ref.svg,
    xScale = _ref.xScale,
    margin = _ref.margin,
    measureUnit = _ref.measureUnit,
    width = _ref.width;
  var height = convertSvgAttribute(svg.style("height"));
  var ticks = measureUnit === "Kronor" ? Math.round(width / 80) : Math.round(width / 50);
  var calleeTop = d3.axisTop(xScale).ticks(ticks).tickSize(0).tickSizeOuter(0).tickPadding(5).tickFormat(function (d) {
    return measureUnit === "Kronor" ? formatKr(d) : d;
  });
  var calleeBottom = d3.axisBottom(xScale).ticks(ticks).tickSize(0).tickSizeOuter(0).tickPadding(5).tickFormat(function (d) {
    return measureUnit === "Kronor" ? formatKr(d) : d;
  });
  svg.select(".xTop").transition().ease(d3.easeQuad).duration(400).attr("transform", "translate(".concat(margin.left, ",").concat(margin.top, ")")).call(calleeTop);
  if (svg.select(".xBottom").attr("needsPlacement") === "true") {
    svg.select(".xBottom").attr("needsPlacement", "false").attr("transform", "translate(".concat(-width, ",").concat(height - margin.bottom, ")"));
  }
  svg.select(".xBottom").transition().duration(400).call(calleeBottom).attr("transform", "translate(".concat(margin.left, ",").concat(height - margin.bottom, ")"));
  svg.selectAll(".xTop, .xBottom").selectAll("path").style("stroke", "#406E75").style("stroke-width", "2px").style("stroke-linecap", "square");
  svg.selectAll(".tick").selectAll("text").style("font-size", "10px").style("fill", "#406E75").style("letter-spacing", ".5px");
}
export function updateGridLines(_ref2) {
  var svg = _ref2.svg,
    margin = _ref2.margin,
    xScale = _ref2.xScale,
    measureUnit = _ref2.measureUnit,
    measurementsWithMetadata = _ref2.measurementsWithMetadata;
  var svgWidth = convertSvgAttribute(svg.style("width"));
  var svgHeight = convertSvgAttribute(svg.style("height"));
  var width = svgWidth - margin.left - margin.right;
  var height = svgHeight - margin.top - margin.bottom;
  var ticks = measureUnit === "Kronor" ? Math.round(width / 80) : Math.round(width / 50);
  var yScale = d3.scaleLinear().domain([0, measurementsWithMetadata.length]).range([0, height]);
  var calleeX = d3.axisBottom(xScale).ticks(ticks).tickSize(height).tickFormat("").tickSizeOuter(0);
  var calleeY = d3.axisLeft(yScale).ticks(measurementsWithMetadata.length).tickSize(-width).tickSizeOuter(0).tickFormat("");
  svg.select(".xGrid").transition().ease(d3.easeQuad).duration(400).attr("transform", "translate(".concat(margin.left, ",").concat(margin.top, ")")).call(calleeX);
  svg.select(".yGrid").transition().ease(d3.easeQuad).duration(400).attr("transform", "translate(".concat(margin.left, ",").concat(margin.top, ")")).call(calleeY);
  svg.selectAll(".xGrid").selectAll("path").style("visibility", "hidden");
  svg.selectAll(".yGrid").selectAll("path").style("visibility", "hidden");
  //svg.selectAll('.grid').style('fill', 'none').style('stroke-width', '1px')
  //svg.selectAll('.grid').selectAll('line, path').style('stroke', '#FFe7e6')
}